import { useState, useEffect } from 'react'
import styles from '../../../pages/LeadCapture/QualifierManager/QualifierManager.module.css'
// Font Awesome assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripVertical, faSquareXmark } from '@fortawesome/free-solid-svg-icons'
// ------ Image Elements ------ //
const grip = <FontAwesomeIcon icon={faGripVertical} style={{ width: '18px', height: '18px' }} />
const squareXmark = <FontAwesomeIcon icon={faSquareXmark} style={{ color: 'red', width: '18px', height: '18px' }} />

const QualifierSelection = ({ qualifierEntry, removeSelection, submitEdit, index, provided, innerRef }) => {
    const [newSelection, setNewSelection] = useState(null)
    const handleChange = (e) => {
        setNewSelection(e.target.value);
        submitEdit(e, e.target.value);
    }
    useEffect(() => {
        setNewSelection(qualifierEntry);
    }, [])
    return (
        <>
            <tr key={qualifierEntry + index}
                {...provided.draggableProps}
                ref={innerRef} className={styles.trQualifiers}>
                <td className={styles.tdQualifiers}>
                    <span className={styles.gripHandle} title="Drag to reorder" {...provided.dragHandleProps}>
                        {grip}
                    </span>
                </td>
                <td className={styles.tdQualifiers}> <textarea
                    id={'edit' + index}
                    autoComplete="off"
                    value={newSelection}
                    name="newSelection"
                    rows="2"
                    cols="35"
                    onChange={handleChange}
                /></td>

                <td className={styles.tdQualifiers}>

                    <button type="button" className={styles.removeButtons} onClick={e => removeSelection(e)} title="Remove selection option." id={'remove' + index}>
                        <i>{squareXmark}</i>
                    </button>
                </td>
            </tr>
        </>
    );
}

export default QualifierSelection;
